// import { Store } from "vuex"

/**
 * @mixin soundMixin
 * @desc サウンド関連共通メソッド
 */
export default {
  methods: {
    /**
     * ルーレット作動中の効果音を再生
     */
    playRouletteSound() {
    if (this.currentGame === 'Home'
      || this.currentGame === 'World'
      || this.currentGame === 'Japan'
      || this.currentGame === 'WorldHard'
      ){
      return
    }
    if (this.soundsMute || this.isActive) {
      return
    }
    this.snd.playRouletteSound()
    },
    /**
     * ルーレット作動中の効果音を停止
     */
    stopRouletteSound() {
    //if (this.soundsMute){
    //  return
    //}
      this.snd.stopRouletteSound()
    },
    /**
     * ルーレット停止の効果音を再生
     */
    playStopSound() {
      if (this.soundsMute) {
        return
      }
      this.snd.rouletteStopSounds.play()
    },
    /**
     * ポップアップアラート表示の効果音を再生
     */
    playPopupSound() {
      if (this.soundsMute) {
        return
      }
      this.snd.playPopupSound()
    },
    /**
     * BGM再生
     */
    playBgmSound() {
      this.snd.playBgmSound()
    },
    /**
     * BGM停止
     */
    stopBgmSound() {
      this.snd.stopBgmSound()
    }
  }
}